import { render, staticRenderFns } from "./defaultWithoutSidebarLogo.vue?vue&type=template&id=1f0e8c40&scoped=true"
import script from "./defaultWithoutSidebarLogo.vue?vue&type=script&lang=js"
export * from "./defaultWithoutSidebarLogo.vue?vue&type=script&lang=js"
import style0 from "./defaultWithoutSidebarLogo.vue?vue&type=style&index=0&id=1f0e8c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0e8c40",
  null
  
)

export default component.exports